import { Flex, Text, Button, FormControl } from '@chakra-ui/react';
import * as Yup from 'yup';
import { Form, Formik, FormikProps } from 'formik';
import axios from 'axios';
import RatingContainer from 'components/RatingContainer';
import ReferenceRatingComment from 'components/ReferenceRatingComment';
import { Ratings } from 'utils';

const AcceptFormValidation = Yup.object().shape({
  attendance: Yup.number().required('This value is required'),
  attendanceComment: Yup.string().required('This value is required'),
  dependability: Yup.number().required('This value is required'),
  dependabilityComment: Yup.string().required('This value is required'),
  qualityOfWork: Yup.number().required('This value is required'),
  qualityOfWorkComment: Yup.string().required('This value is required'),
  jobCompentence: Yup.number().required('This value is required'),
  jobCompentenceComment: Yup.string().required('This value is required'),
  workWithAgain: Yup.bool().required('This value is required'),
  workWithAgainComment: Yup.string().required('This value is required'),
});

const AcceptReferenceForm = ({
  referenceId,
  referenceRequestId,
  afterSubmit,
}: AcceptReferenceFormProps): JSX.Element => {
  const submitReference = async (referenceDetails: UpdateReferenceDetails) => {
    await axios({
      baseURL: process.env.REACT_APP_FUNCTIONS_URL,
      url: '/references/submitReference',
      method: 'POST',
      data: {
        ...referenceDetails,
      },
    });
  };
  return (
    <Formik
      key="accept"
      validationSchema={AcceptFormValidation}
      initialValues={{
        attendance: 0,
        attendanceComment: '',
        dependability: 0,
        dependabilityComment: '',
        qualityOfWork: 0,
        qualityOfWorkComment: '',
        jobCompentence: 0,
        jobCompentenceComment: '',
        workWithAgain: undefined,
        workWithAgainComment: '',
      }}
      onSubmit={async (vals, { setErrors, setStatus, setSubmitting }) => {
        setStatus(null);
        try {
          setSubmitting(true);
          await submitReference({
            referenceId,
            referenceRequestId,
            status: 'completed',
            ...vals,
          });
          afterSubmit();
        } catch (error) {
          setStatus(error);
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({
        values,
        isSubmitting,
        setFieldValue,
      }: FormikProps<AcceptReferenceValues>) => (
        <Form
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            backgroundColor: '#FDFBF6',
          }}
        >
          {Ratings.map(({ title, key, commentKey, descriptions }) => (
            <RatingContainer
              key={`${key}-rating`}
              title={title}
              ratingKey={key}
              value={values[key]}
              commentValue={values[commentKey]}
              descriptions={descriptions}
              setFieldValue={setFieldValue}
            />
          ))}
          <Flex direction="column" bg="white" width="100%" p={4} mb={3}>
            <Text
              fontWeight={700}
              fontSize="16px"
              lineHeight="19.2px"
              letterSpacing="3%"
              textAlign="center"
              mb={6}
            >
              Would you work with this person again?
            </Text>
            <Flex direction="row" bg="white" mb={6}>
              <FormControl
                id="workWithAgain"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                width="100%"
              >
                <Button
                  borderRadius="40px"
                  px="24px"
                  py="12px"
                  minWidth="140px"
                  bg={values.workWithAgain ? 'black' : 'white'}
                  color={values.workWithAgain ? 'white' : 'black'}
                  borderColor="#999999"
                  borderWidth="1px"
                  mr={3}
                  width="unset"
                  onClick={() => setFieldValue('workWithAgain', true)}
                >
                  Yes
                </Button>
                <Button
                  borderRadius="40px"
                  px="24px"
                  py="12px"
                  minWidth="140px"
                  bg={
                    values.workWithAgain !== undefined && !values.workWithAgain
                      ? 'black'
                      : 'white'
                  }
                  color={
                    values.workWithAgain !== undefined && !values.workWithAgain
                      ? 'white'
                      : 'black'
                  }
                  borderColor="#999999"
                  borderWidth="1px"
                  mr={3}
                  width="unset"
                  onClick={() => setFieldValue('workWithAgain', false)}
                >
                  No
                </Button>
              </FormControl>
            </Flex>
            <ReferenceRatingComment
              comment="workWithAgainComment"
              value={values.workWithAgainComment}
              setFieldValue={setFieldValue}
            />
          </Flex>
          <Flex direction="column" alignItems="center" justifyContent="center">
            <Button
              type="submit"
              px="56px"
              py="12px"
              borderRadius={20}
              boxShadow="lg"
              mt={2}
              mb={8}
              fontSize="15px"
              fontWeight={400}
              bg="custom.levoYellow"
              isLoading={isSubmitting}
            >
              Submit
            </Button>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};

export default AcceptReferenceForm;
